import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { password_edit_api, ResetPassword, Sources, User_Registration } from '../models/User';
import { PromiseResult } from '../models/PromiseResult';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VendorPatientService {
    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    constructor(
        private readonly http: HttpClient
    ) { }


    requestotp(user_guid: string, client_id: string, vendor_id: string): Observable<PromiseResult> {
        const params = new HttpParams()
            .set('user_guid', user_guid)
            .set('vendor_id', vendor_id)
            .set('client_id', client_id);
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.VendorApi + 'patient/auth/otp/request', 
                { params }
            ).pipe(catchError(this.handleError));
    }

}
